/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BusinessCostsResponse,
  BusinessCostsV2Response,
  GigCostsBusinessRetrieve400,
  GigCostsBusinessRetrieveParams,
  GigCostsV2BusinessRetrieveParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGigCostsBusinessRetrieveUrl = (params: GigCostsBusinessRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gig-costs/business/?${stringifiedParams}` : `/api/gig-costs/business/`
}

/**
 * Calculates the business costs for a gig. Note the query params are in camel case.
 */
export const gigCostsBusinessRetrieve = async (params: GigCostsBusinessRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<BusinessCostsResponse> => {

  return customFetch<BusinessCostsResponse>(getGigCostsBusinessRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigCostsBusinessRetrieveQueryKey = (params?: GigCostsBusinessRetrieveParams,) => {
    return [
    `/api/gig-costs/business/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigCostsBusinessRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError = GigCostsBusinessRetrieve400 | void>(params: GigCostsBusinessRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigCostsBusinessRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>> = ({ signal }) => gigCostsBusinessRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigCostsBusinessRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>>
export type GigCostsBusinessRetrieveQueryError = GigCostsBusinessRetrieve400 | void


export function useGigCostsBusinessRetrieve<TData = Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError = GigCostsBusinessRetrieve400 | void>(
 params: GigCostsBusinessRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigCostsBusinessRetrieve<TData = Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError = GigCostsBusinessRetrieve400 | void>(
 params: GigCostsBusinessRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigCostsBusinessRetrieve<TData = Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError = GigCostsBusinessRetrieve400 | void>(
 params: GigCostsBusinessRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigCostsBusinessRetrieve<TData = Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError = GigCostsBusinessRetrieve400 | void>(
 params: GigCostsBusinessRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsBusinessRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigCostsBusinessRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigCostsV2BusinessRetrieveUrl = (params?: GigCostsV2BusinessRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gig-costs/v2/business/?${stringifiedParams}` : `/api/gig-costs/v2/business/`
}

/**
 * Returns an itemized business cost breakdown including platform fees, processing fees, tips, discounts, and totals.
 *
 * ## Parameters
 *
 * Supply one of: `gig_application_id`, `gig_id`, `location_id`, or none. Resolution priority: `gig_application_id` > `gig_id` > `location_id`.
 *
 * - **No ID**: pass `hourly_wage`, `shift_start_time`, `shift_end_time` (required), plus any optional fee/tip/coupon params.
 * - **`gig_id`**: resolves wage, times, breaks, fees from gig/location. Overridable: `tip_amount`, `credit_id`, `discount_code`, `available_discount`.
 * - **`gig_application_id`**: resolves everything including working hours, in-network status, tip (from Tip record), and coupon (from ApplicationCredit). Overridable: `tip_amount`, `credit_id`, `discount_code`, `available_discount`. If the application is already paid, returns stored Payment values directly (no recalculation, no overrides).
 *
 * ## Override rules
 *
 * When an ID is provided, most params are **locked** to DB values. Passing a locked param returns a 400 with the list of rejected params.
 *
 * **Locked when any ID is provided**: `hourly_wage`, `shift_start_time`, `shift_end_time`, `payment_method_type`, `gigpro_fee_percentage`, `gigpro_flat_fee`, `tipping_fee_percentage`, `background_checks_fee_percentage`, `unpaid_break_minutes`, `location_id`.
 *
 * ## Authentication
 *
 * Requires an authenticated user. When `gig_application_id` or `gig_id` is provided, the user must be an active location manager for the associated location or a GigPro admin. Onsite and gig managers of that gig are denied (403).
 */
export const gigCostsV2BusinessRetrieve = async (params?: GigCostsV2BusinessRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<BusinessCostsV2Response> => {

  return customFetch<BusinessCostsV2Response>(getGigCostsV2BusinessRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigCostsV2BusinessRetrieveQueryKey = (params?: GigCostsV2BusinessRetrieveParams,) => {
    return [
    `/api/gig-costs/v2/business/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigCostsV2BusinessRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError = void>(params?: GigCostsV2BusinessRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigCostsV2BusinessRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>> = ({ signal }) => gigCostsV2BusinessRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigCostsV2BusinessRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>>
export type GigCostsV2BusinessRetrieveQueryError = void


export function useGigCostsV2BusinessRetrieve<TData = Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError = void>(
 params: undefined |  GigCostsV2BusinessRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigCostsV2BusinessRetrieve<TData = Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError = void>(
 params?: GigCostsV2BusinessRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigCostsV2BusinessRetrieve<TData = Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError = void>(
 params?: GigCostsV2BusinessRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigCostsV2BusinessRetrieve<TData = Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError = void>(
 params?: GigCostsV2BusinessRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigCostsV2BusinessRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigCostsV2BusinessRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






